/** The public site's canonical origin, the one place the portal names it. */
export const SITE_ORIGIN = 'https://zerohuman.com'

/** A docs path (`/docs/api/authentication`, with or without the leading slash) as an absolute URL on the site. */
export function docsUrl(path: string): string {
    return `${SITE_ORIGIN}/${path.replace(/^\/+/, '')}`
}
